import { Dialog, useQuasar } from 'quasar'
import { useI18n } from 'vue-i18n'
import BluConfirmDialog from '@/components/common/BluConfirmDialog.vue'

function normalizeButton (btn, fallbackLabel) {
  if (btn === false || btn == null) return null
  if (btn === true) {
    return { label: fallbackLabel, flat: true, color: 'primary' }
  }
  if (typeof btn === 'string') {
    return { label: btn, flat: true, color: 'primary' }
  }
  return btn
}

function defaultHeaderClass (okColor) {
  return okColor === 'negative' ? 'dialog-header--amber' : 'dialog-header--slate'
}

function buildConfirmProps ({
  title,
  message,
  html = false,
  cancel = true,
  ok = true,
  persistent = true,
  headerClass,
  prompt,
  options,
  t
}) {
  const translate = (key, fallback) => (typeof t === 'function' ? t(key) : fallback)
  const okBtn = normalizeButton(ok, translate('shared.ok', 'OK'))
  const cancelBtn = normalizeButton(cancel, translate('shared.cancel', 'Cancel'))
  const okColor = okBtn?.color ?? 'primary'

  return {
    title,
    message,
    html,
    persistent,
    prompt,
    options,
    headerClass: headerClass ?? defaultHeaderClass(okColor),
    okLabel: okBtn?.label ?? translate('shared.ok', 'OK'),
    okColor,
    okFlat: okBtn?.flat ?? false,
    okUnelevated: okBtn?.unelevated ?? !(okBtn?.flat ?? false),
    cancelLabel: cancelBtn?.label ?? translate('shared.cancel', 'Cancel'),
    cancelColor: cancelBtn?.color ?? 'primary',
    showCancel: cancelBtn != null
  }
}

export function bluConfirm (opts) {
  return Dialog.create({
    component: BluConfirmDialog,
    componentProps: buildConfirmProps(opts)
  })
}

export function useBluDialog () {
  const $q = useQuasar()
  const { t } = useI18n()

  function confirm (opts = {}) {
    return $q.dialog({
      component: BluConfirmDialog,
      componentProps: buildConfirmProps({ ...opts, t })
    })
  }

  return { confirm }
}
